<script>
export default {
    props: ['params'],
    components: {
        'base-submit-block': () => import('@/components/base/BaseSubmitBlock')
    },
    data() {
        return {
            content: '',
            isLoading: true,
            buttons: {
                submit: {
                    show: false,
                    id: '',
                    name: this.$t('Save'),
                    saveUrl: '',
                    onPreSave: () => {
                    },
                    data: {},
                    on: {}
                },
                or: {
                    show: true,
                    text: this.$t('or')
                },
                cancel: {
                    show: true,
                    text: this.$t('cancel'),
                    onClose: () => {

                    }
                }
            },
        }
    },
    created() {
        // Настраиваем кнопки
        if (this.params.buttons) {
            if (this.params.buttons.submit) {
                this.buttons['submit']['show'] = true;
                this.buttons['submit'] = {
                    ...this.buttons['submit'],
                    ...this.params.buttons['submit']
                };
            }
            this.buttons['submit']['button'] = this.buttons['submit']['name'];
            if (this.params.saveData) {
                this.buttons['submit']['data'] = this.params.saveData;
            }

            if (this.params.buttons.or) {
                this.buttons['or'] = {
                    ...this.buttons['or'],
                    ...this.params.buttons['or']
                };
            }

            if (this.params.buttons.cancel) {
                this.buttons['cancel'] = {
                    ...this.buttons['cancel'],
                    ...this.params.buttons['cancel']
                };
            }

            if (!this.buttons['submit']['show'] && !this.params.buttons.or) {
                this.buttons.or.show = false;
            }
        }
        if (typeof this.params.closeWatcher !== 'undefined') {
            this.$watch('params.closeWatcher', function (newVal) {
                if (newVal) {
                    this.$emit('close');
                }
            })
        }
    },
    render(createElement) {
        const title = this.getTitle;
        const content = this.getContent;
        const footer = this.getFooter();

        return createElement(
            'div', {
                staticClass: 'vue-dialog-wrap' + (this.params?.modalParams?.fixedFooter ? ' vue-dialog-fixed-footer' : '')
            }, [title, content, footer]
        );
    },
    computed: {
        getTitle() {
            const h = this.$createElement;
            const self = this;

            if (this.params.title) {
                const closeCross = this.params?.modalParams?.closeCross ? h('span', {
                    staticClass: 'dialog-c-close',
                    on: {
                        click: () => self.$emit('close')
                    }
                }) : h('');
                return h('div', {
                    staticClass: 'dialog-c-title'
                }, [
                    h('h1', [this.params.title, closeCross])
                ]);
            } else {
                return h('');
            }
        },
        getContent() {
            const self = this;
            const h = self.$createElement;

            if (self.params.component) {
                let events = {
                    loaded() {
                        self.isLoading = false;
                    }
                }
                if (self.params?.componentParams?.on) {
                    events = Object.assign({}, events, self.params.componentParams.on);
                    delete self.params.componentParams.on;
                }
                self.content = h(self.params.component, {
                    props: self.params.componentParams || {},
                    on: events
                });
            } else {
                self.content = self.params.$slots.default || '';
            }
            if (!self.params.waitComponentLoaded) {
                self.isLoading = !self.content;
            }

            let contentParams = {
                staticClass: 'vue-dialog-content'
            };

            if (this.params?.modalParams?.contentId) {
                contentParams['attrs'] = {
                    id: this.params.modalParams.contentId
                }
            }

            return h('div', contentParams, [
                h('div', {
                    staticClass: 'dialog-c-text'
                }, [
                    (self.content ? self.content : ''),
                    h('div', {
                        staticClass: 'align-center',
                        directives: [{
                            name: "show",
                            rawName: "v-show",
                            value: (self.isLoading),
                            expression: "isLoading"
                        }]
                    }, [
                        h('img', {
                            attrs: {
                                src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjAiIHdpZHRoPSI2NHB4IiBoZWlnaHQ9IjY0cHgiIHZpZXdCb3g9IjAgMCAxMjggMTI4IiB4bWw6c3BhY2U9InByZXNlcnZlIj48Zz48Y2lyY2xlIGN4PSIxNiIgY3k9IjY0IiByPSIxNiIgZmlsbD0iIzAwMDAwMCIgZmlsbC1vcGFjaXR5PSIxIi8+PGNpcmNsZSBjeD0iMTYiIGN5PSI2NCIgcj0iMTQuMzQ0IiBmaWxsPSIjMDAwMDAwIiBmaWxsLW9wYWNpdHk9IjEiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDY0IDY0KSIvPjxjaXJjbGUgY3g9IjE2IiBjeT0iNjQiIHI9IjEyLjUzMSIgZmlsbD0iIzAwMDAwMCIgZmlsbC1vcGFjaXR5PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA2NCA2NCkiLz48Y2lyY2xlIGN4PSIxNiIgY3k9IjY0IiByPSIxMC43NSIgZmlsbD0iIzAwMDAwMCIgZmlsbC1vcGFjaXR5PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgxMzUgNjQgNjQpIi8+PGNpcmNsZSBjeD0iMTYiIGN5PSI2NCIgcj0iMTAuMDYzIiBmaWxsPSIjMDAwMDAwIiBmaWxsLW9wYWNpdHk9IjEiIHRyYW5zZm9ybT0icm90YXRlKDE4MCA2NCA2NCkiLz48Y2lyY2xlIGN4PSIxNiIgY3k9IjY0IiByPSI4LjA2MyIgZmlsbD0iIzAwMDAwMCIgZmlsbC1vcGFjaXR5PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgyMjUgNjQgNjQpIi8+PGNpcmNsZSBjeD0iMTYiIGN5PSI2NCIgcj0iNi40MzgiIGZpbGw9IiMwMDAwMDAiIGZpbGwtb3BhY2l0eT0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoMjcwIDY0IDY0KSIvPjxjaXJjbGUgY3g9IjE2IiBjeT0iNjQiIHI9IjUuMzc1IiBmaWxsPSIjMDAwMDAwIiBmaWxsLW9wYWNpdHk9IjEiIHRyYW5zZm9ybT0icm90YXRlKDMxNSA2NCA2NCkiLz48YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgdmFsdWVzPSIwIDY0IDY0OzMxNSA2NCA2NDsyNzAgNjQgNjQ7MjI1IDY0IDY0OzE4MCA2NCA2NDsxMzUgNjQgNjQ7OTAgNjQgNjQ7NDUgNjQgNjQiIGNhbGNNb2RlPSJkaXNjcmV0ZSIgZHVyPSI3MjBtcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiPjwvYW5pbWF0ZVRyYW5zZm9ybT48L2c+PC9zdmc+"
                            }
                        })
                    ])
                ])
            ])
        },
        isShowButtons() {
            return this.buttons.submit.show || this.buttons.or.show || this.buttons.cancel.show;
        }
    },
    methods: {
        getFooter() {
            const h = this.$createElement;
            const buttons = this.getButtons();
            let footer = h('');

            if (this.params.footer) {
                if (typeof this.params.footer.component !== 'undefined') {
                    footer = h(this.params.footer.component, {
                        props: this.params.footer.params || {},
                        on: this.params.footer.on || {},
                    })
                } else {
                    footer = h('div', {
                        staticClass: 'dialog-c-footer-static',
                        domProps: {
                            innerHTML: this.params.footer
                        }
                    })
                }
            }

            return h('div', {
                staticClass: 'dialog-c-footer'
            }, [buttons, footer]);
        },
        getButtons() {
            const self = this;
            const h = self.$createElement;
            if (self.isShowButtons && !self.isLoading) {
                const buttons = [];

                if (self.buttons.submit.show) {
                    let events = {
                        'pre-save': self.buttons['submit']['onPreSave'],
                    };

                    if (self.buttons.submit.on) {
                        events = Object.assign({}, events, self.buttons.submit.on);
                    }
                    if (self.buttons['submit']['closeOnSubmit']) {
                        events['saved'] = () => self.$emit('close');
                    }

                    buttons.push(h('base-submit-block', {
                        props: self.buttons['submit'],
                        on: events
                    }))
                }

                if (self.buttons.or.show) {
                    buttons.push(h('span', [self.buttons.or.text]))
                }
                if (self.buttons.cancel.show) {
                    buttons.push(h('a', {
                        attrs: { href: '#' },
                        on: {
                            click(event) {
                                event.preventDefault();
                                self.$emit('close')
                            }
                        }
                    }, [self.buttons.cancel.text]))
                }

                return h('div', {
                    staticClass: 'block dialog-c-buttons'
                }, buttons)
            } else {
                return h('');
            }
        }
    }
}
</script>